import PropTypes from 'prop-types';
import React from 'react';
import bemify from 'bemify-js';

import AvatarOrTeamLogoContainer from 'app/common/components/AvatarOrTeamLogoContainer';
import Icon from 'app/common/components/Icon';
import TruncatedText from 'app/common/components/TruncatedText';
import 'app/common/components/AccountChoice.scss';

const bem = bemify('account-choice');

const AccountChoice = props => (
  <div className={bem(props.className)}>
    <AvatarOrTeamLogoContainer
      accountId={props.id}
      className={bem('__logo')}
      size={32}
    />
    <TruncatedText className={bem('__name')}>{props.name}</TruncatedText>
    {props.isActive ? (
      <Icon className={bem('__active-icon')} type="check-alt" />
    ) : null}
  </div>
);

AccountChoice.propTypes = {
  className: PropTypes.string,
  isActive: PropTypes.bool,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
};

export default AccountChoice;
